import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/out/order/page', Object.assign({}, options, { params }));

export const getList_ = (params) =>
request.get('/api/v4ward/out/order/page?'+params);

export const getDetail = (params, options) =>
request.get('/api/v4ward/out/order/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/out/order/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/out/order/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/out/order/submit', params,options)



export const getGroupById = (params, options) =>
request.get('/api/v4ward/out/order/getGroupById', Object.assign({}, options, { params }))


export const appointOrder = (params, options) =>
request.post('/api/v4ward/out/order/execute/appoint', params,options)
// request.get('/api/v4ward/out/order/execute/appoint', Object.assign({}, options, { params }))


export const grabOrder = (params, options) =>
request.post('/api/v4ward/out/order/execute/grabSingle', params,options)
// request.get('/api/v4ward/out/order/execute/grabSingle', Object.assign({}, options, { params }))


export const cancelOrder = (params, options) =>
request.post('/api/v4ward/out/order/execute/cancel', params,options)
// request.get('/api/v4ward/out/order/execute/cancel', Object.assign({}, options, { params }))

export const createOrder = (params, options) =>
request.post('/api/v4ward/out/order/execute/create', params,options)


// /api/blade-system/dict/dictionary?code=order_urgent_level


export const getOrderUrgentLevel = (params, options) =>
request.get('/api/blade-system/dict/dictionary?code=order_urgent_level', Object.assign({}, options, { params }))

export const getModuleType = (params, options) =>
request.get('/api/blade-system/dict/dictionary?code=module_type', Object.assign({}, options, { params }))

// 字典
export const getDictionary = (params, options) =>
request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))


// 字典
export const getGroupName = (params, options) =>
request.get('/api/v4ward/out/order/execute/getGroupDetails', Object.assign({}, options, { params }))


// 获取详情
export const getOrderDetail = (params, options) =>
request.get(`/api/v4ward/out/order/details/${params.orderId}`, Object.assign({}, options, {  }))


// 字典
export const getDictData = (params, options) =>
    request.get('/api/blade-system/dict/dictionary?code='+params, Object.assign({}, options, { params }));

// ?projectId=1325995166552199169&moduleType=2


// 字典
export const getDeptDetailByAreaId = (params, options) =>
    request.get('/api/v4ward/area/getDeptDetailByAreaId', Object.assign({}, options, { params }));

// 字典
export const getDeptUserListByDeptId = (params, options) =>
    request.get('/api/v4ward/user/getDeptUserListByDeptId', Object.assign({}, options, { params }));

// 字典
export const getSubModuleList = (params, options) =>
    request.get('/api/v4ward/out/order/execute/getSubModuleList', Object.assign({}, options, { params }));

// 字典
export const getProviderList = (params, options) =>
    request.get('/api/v4ward/out/service/provider/list', Object.assign({}, options, { params }));
        
// 字典
export const getServiceItemList = (params, options) =>
    request.get('/api/v4ward/out/order/service/item/list', Object.assign({}, options, { params }));

export const getSubModuleListByOrderFlag = (params, options) =>
    request.get('/api/v4ward/out/order/execute/getSubModuleListByOrderFlag', Object.assign({}, options, { params }));

// 字典
export const getAllSubModuleList = (params, options) =>
  request.get('/api/v4ward/out/order/execute/getAllSubModuleList', Object.assign({}, options, { params }));
    
    
